import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

// Mostrado durante a chamada de exportarExcel. Backend reporta a etapa atual
// via polling em /gestao-iptu/exportar-excel/progresso/{id}:
//   "Buscando imóveis…" → "Buscando fornecedores…" → "Gerando arquivo Excel…"
//   → "Finalizando…"
// Substitui a barra de progresso por uma indicação de fase (sem contagem) —
// decisão 2026-05-12 após barra animada/real não dar feedback satisfatório.
const ModalExportEtapa = ({ show, etapa }) => (
  <Modal show={show} backdrop="static" centered size="sm" keyboard={false}>
    <Modal.Body className="text-center py-4">
      <Spinner animation="border" variant="primary" style={{ width: 40, height: 40 }} />
      <div style={{ fontSize: 14, fontWeight: 600, color: '#001f5b', marginTop: 12 }}>
        {etapa || 'Aguarde…'}
      </div>
    </Modal.Body>
  </Modal>
);

export default ModalExportEtapa;
